export default __webpack_public_path__ + "static/media/email-success.55720f0e.svg";